export function formatNumber(value: number, precision?: number) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: precision,
    minimumFractionDigits: precision
  })

  return formatter.format(value)
}
